import { twMerge } from 'tailwind-merge';
import { MenuItem } from '@/features/layout/types/layout.types';

const NavItem = ({ title, Icon, selected, onClick, comingSoon }: MenuItem) => {
  return (
    <div
      onClick={onClick}
      className={twMerge(comingSoon ? 'cursor-default' : 'cursor-pointer', 'flex items-center gap-2')}
    >
      <Icon size={24} className={twMerge(selected ? 'text-ph-primary-violet' : 'text-ph-gray-evening')} />
      <span
        className={twMerge(
          'min-w-18 text-base font-semibold',
          selected ? 'text-ph-gray-white' : 'text-ph-gray-evening',
        )}
      >
        {title}
      </span>
    </div>
  );
};

export default NavItem;
